import ReactDOM from 'react-dom/client';

import '@/i18n';

import { AppProviders } from '@/contexts/appProviders.tsx';
import { STATUS } from '@/core';

import { App } from './App';

declare module '@mui/material/styles' {
  interface Palette {
    accepted: {
      main: string;
      light: string;
    };
    status: {
      [key in STATUS]: {
        main: string;
        background: string;
      };
    };
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    custom: true;
  }
}

// INFO: declaration is in /env.js
declare global {
  // tslint:disable-next-line
  interface Window {
    API_URL: string;
    ENVIRONMENT: string;
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <AppProviders>
    <App />
  </AppProviders>,
);
